import React, { memo } from 'react';
import { HeaderSkeleton } from 'site-modules/personalized-search/components/header-content/header-skeleton/header-skeleton';

export const AnchorSkeleton = memo(() => (
  <div className="base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto">
    <HeaderSkeleton />
  </div>
));

AnchorSkeleton.displayName = 'AnchorSkeleton';
